import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    corporationId: string;
    loanRequestId: string;
};

export const schemaLoanRequestResolver_IsOfCorporation = z.boolean();

export type SchemaLoanRequestResolver_IsOfCorporation = z.infer<typeof schemaLoanRequestResolver_IsOfCorporation>;

export type LoanRequestResolver_IsOfCorporation = Resolver<Arguments, SchemaLoanRequestResolver_IsOfCorporation>;
